import { vsprintf } from "sprintf-js";
import { API_ENDPOINT, API_VERSION, httpMethods } from "../../constants";
import { rootStore } from "../../redux/store";
import { setErrorState } from "../../redux/error_banner/actions";
import { trackingEventNames } from "../../helpers/pendo_constants";

export async function updateBxCore(input) {
    return await fetch(
        vsprintf("%s/api/%s/tplan_store/patient/%s/plan/%s/bx", [
            API_ENDPOINT,
            API_VERSION,
            input.patientuuid,
            input.planuuid,
        ]),
        {
            method: httpMethods.PUT,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${input.token}`,
            },
            body: JSON.stringify({
                coreIdx: input.coreIdx,
                bx: input.bx,
            }),
            mode: "cors",
        }
    )
        .then((response) => response.json())
        .catch((e) => {
            rootStore.dispatch(
                setErrorState(
                    true,
                    trackingEventNames.UPDATE_BIOPSY_CORE,
                    input.planuuid,
                    String(e)
                )
            );
            return null;
        });
}

export function getMaxGleasonGradeGroupFromCores(bxCores) {
    let maxGgg = 0;
    bxCores.forEach((core) => {
        if (core.GleasonGradeGroup > maxGgg) {
            maxGgg = core.GleasonGradeGroup;
        }
    });
    return maxGgg;
}

export function getValidCEMCores(bxCores) {
    let validBx = [];
    bxCores.forEach((core) => {
        if (core.GleasonGradeGroup >= 2 && !core.IsMuted) {
            validBx.push(core);
        }
    });
    return validBx.length > 0;
}

export const mouseEventIsWithinCanvas = (event, canvas) => {
    return (
        event.clientX >= canvas.left &&
        event.clientX <= canvas.right &&
        event.clientY >= canvas.top &&
        event.clientY <= canvas.bottom
    );
};

export const isAnyCorePositiveCheck = (plan) => {
    let cores = plan?.TreatmentPlan?.StructureData?.Biopsy;
    if (cores) {
        for (let i = 0; i < cores.length; i++) {
            if (cores[parseInt(i)].GleasonGradeGroup >= 1) {
                return true;
            }
        }
    }
    return false;
};
